import { withRedemptionToken } from '@utils/redemptionRoute';
import { ArrowRight, Plus, UserRound } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router';

import { RedemptionLayout } from './RedemptionLayout';
import mark from '../../../assets/no-text-logo-remente.svg';

export const AccountChoice = ({ token }: { token: string }) => {
  const { t } = useTranslation();

  return (
    <RedemptionLayout step={0} showCodeNote>
      <div className="redemption-welcome">
        <img className="redemption-mark" src={mark} alt="" />
        <p className="redemption-eyebrow">{t('flow.eyebrow')}</p>
        <h1>{t('flow.welcome')}</h1>
        <p className="redemption-body">{t('flow.intro')}</p>
      </div>
      <div className="redemption-choices">
        <Link className="redemption-choice existing" to={withRedemptionToken('/login', token)}>
          <span className="redemption-choice-icon">
            <UserRound size={23} aria-hidden="true" />
          </span>
          <span>
            <strong>{t('flow.existing')}</strong>
            <small>{t('flow.existing_help')}</small>
          </span>
          <ArrowRight className="redemption-choice-arrow" size={20} aria-hidden="true" />
        </Link>
        <Link className="redemption-choice" to={withRedemptionToken('/signup', token)}>
          <span className="redemption-choice-icon">
            <Plus size={24} aria-hidden="true" />
          </span>
          <span>
            <strong>{t('flow.new')}</strong>
            <small>{t('flow.new_help')}</small>
          </span>
          <ArrowRight className="redemption-choice-arrow" size={20} aria-hidden="true" />
        </Link>
      </div>
      <p className="redemption-note redemption-choice-note">{t('flow.existing_note')}</p>
    </RedemptionLayout>
  );
};
